<div
    *ngIf="!mention?.translation?.failedToTranslate"
    class="agpr-mentionLanguage"
    [ngClass]="{
        'agpr-mentionLanguage-editMention': isEditMention
    }"
>
    <div class="agpr-mentionLanguage-label">
        <span *ngIf="showLanguageLabel">{{ 'Mention.translated' | localize }}: </span>
        {{ (mention?.language ? 'Language.' + mention?.language : 'Language.en') | localize }}
        <span  aria-hidden="true" class="agpr-mentionLanguage-arrow fa-regular fa-arrow-right"></span>

        <span *ngIf="!showActions">
            {{ mention?.translation?.language ?
                ('Language.' + mention?.translation?.language | localize) : mention?.translation?.languageString ?
                mention?.translation?.languageString : 'N/A'}}
        </span>
    </div>

    <div
        *ngIf="showActions"
        class="agpr-mentionLanguage-actions"
        [ngClass]="{'agpr-mentionLanguage-actions--halfWidth': isHalfWidth}"
        [agprTooltip]="(concurrentTranslation >= maxConcurrentTranslation) ?
            ('Mention.translate.tooManyRequests' | localize : {
                max : maxConcurrentTranslation
            }) : ''"
    >
        <agpr-autocomplete
            [id]="id+'_languages'"
            class="agpr-mentionLanguage-dropdown"
            [ngClass]="{
                'agpr-mentionLanguage-dropdown-longer': isEditMention
            }"
            labelField="label"
            ariaLabel="Mention.translateDropdown"
            [dropdown]="true"
            [(ngModel)]="selectedLanguage"
            [suggestions]="languageSuggestions$"
            [multiSelection]="false"
            [disabled]="mention?.translating || (concurrentTranslation >= maxConcurrentTranslation)"
            [clearOnBlur]="false"
            (searchStringChanged)="updateListAfterString($event)"
            (blur)="onLanguageBlur()"
        ></agpr-autocomplete>
        <agpr-button
            [style]="buttonTypes.block"
            [id]="id+'_button'"
            (click)="translate()"
            [icon]="'fa-kit-duotone fa-agpr-translate'"
            [disabled]="mention?.translating || (concurrentTranslation >= maxConcurrentTranslation) || !mention?.body"
            [tooltip]="mention?.translating ? 'Mention.translating' :
                (concurrentTranslation < maxConcurrentTranslation) ?
                ('Mention.translateTo' | localize: {
                    language: selectedLanguage?.label
                }) : ''"
            tooltipPosition="top"
        ></agpr-button>
    </div>
</div>
<div *ngIf="mention?.translation?.failedToTranslate">
    {{ 'Mention.failedToTranslate' | localize }}
</div>
